import { createApi } from '@reduxjs/toolkit/query/react';
import PaginatedResult from '../../types/paginatedResult';
import { buildPaginatedQuery, safeBaseQuery } from './functions';
import { BranchCreateDto, BranchDto } from '../../types/branch';
import { CompanyStatus, Country } from '../../constants/enums';

export interface BranchFilters {
    name?: string;
    country?: Country[];
    companyId?: number[];
    mainLanguageId?: number[];
    status?: CompanyStatus[];
    zipCode?: string;
    county?: string;
    district?: string;
    cityDistrict?: string;
    municipality?: string;
    village?: string;
    street?: string;
    address?: string;
    addressDetails?: string;
    addressDetails2?: string;
}

const branch = createApi({
    reducerPath: 'apiBranch',
    baseQuery: safeBaseQuery('branch'),
    endpoints: (builder) => ({
        getBranchById: builder.query<BranchDto, number>({
            query: (id) => `/${id}`,
        }),
        getBranches: builder.query<
            PaginatedResult<BranchDto>,
            {
                filters?: BranchFilters;
                page?: number;
                pageSize?: number;
                orderBy?: string;
                asc?: boolean;
            }
        >({
            query: (args = {}) => buildPaginatedQuery<BranchFilters>(args),
        }),
        createBranch: builder.mutation<BranchDto, BranchCreateDto>({
            query: (newBranch) => ({
                url: '/',
                method: 'POST',
                body: newBranch,
            }),
        }),
    }),
});

export const {
    useGetBranchesQuery,
    useLazyGetBranchesQuery,
    useLazyGetBranchByIdQuery,
    useCreateBranchMutation,
    useGetBranchByIdQuery,
} = branch;
export default branch;
